import type * as React from "react";
import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input"> & {
  variant?: keyof typeof variants;
};

const variants = {
  default: "bg-input border-input",
  light: "bg-white border-transparent",
} as const;

function Input({ className, type, variant = "default", ...props }: InputProps) {
  return (
    <input
      className={cn(
        "flex h-10 w-full min-w-0 rounded-form-element border px-4 py-3 text-base outline-none transition-[color,box-shadow] selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className,
        variants[variant]
      )}
      data-slot="input"
      type={type}
      {...props}
    />
  );
}

export { Input };
